<template>
  <div class="background">
  <div class="chart-container">
    <div v-html="styleText"></div>
    <div @click="printPdf" class="noPrint">{{$t('print')}}</div>
    <div class="Hcp-main-header">
      <div class="main-header-left">
        <img src="../../assets/LOGO.png">
      </div>
      <div class="main-header-right">
        <p>{{$t('TrendRe')}}</p>
        <p style="font-size: 13px;">{{$t('period')}}: {{timeRange}}</p>
      </div>
    </div>
    <table class="status-table1" :class="{'zh1':!isEn,'de1':isDe||isIt}">
      <tr>
        <td class="td1 td2">{{$t('uername')}}</td><td colspan="4" class="td2">{{statics.username}}</td>
        <td class="td1 td2">{{$t('fullName')}}</td><td colspan="4" class="td3">{{statics.name}}</td>
      </tr>
      <tr>
        <td rowspan="3" class="td1 td2">{{$t('devices')}}</td>
        <td class="td2" id="reportPdmTitle">{{$t('pdm')}}</td><td colspan="8" class="td3">{{devices[0]}}</td>
      </tr>
      <tr><td class="td2">{{$t('tran')}}</td><td colspan="8" class="td3">{{devices[1]}}</td></tr>
      <tr><td class="td2">{{$t('pumpBase')}}</td><td colspan="8" class="td3">{{devices[2]}}</td></tr>
      <tr>
        <td class="td1 td4">{{$t('disType')}}</td><td colspan="9" class="td4">{{statics.medical_history}}</td>
        <!--<td class="td td4">{{$t('HbA1c')}}</td><td colspan="4">{{hb1c[0]}}</td>-->
      </tr>
    </table>

    <div class="small-hr"></div>
    <el-row>
      <el-col :span="24">
        <img id="img4_1" class="graph">
      </el-col>
    </el-row>
    <div class="statics">
      <p>{{$t('static')}}</p>
      <table class="statics-table" >
        <tr>
          <td rowspan="2" width="9%" class="td1">{{$t('static')}}</td>
          <td colspan="10" width="29%" class="td1">{{$t('Basics')}}</td>
          <td colspan="3"  class="td1">{{$t('distri')}}%</td>
          <td colspan="4" width="20%"  class="td1">{{$t('stab')}}</td>
          <td colspan="7" class="td2">{{$t('BG1')}}</td>
        </tr>
        <tr>
          <td class="td2">{{$t('Avg')}}</td> <td class="td2">{{$t('max')}}</td> <td class="td2">{{$t('min')}}</td> <td class="td2">{{$t('Med')}}</td>
          <td class="td2">{{$t('Q1')}}</td><td class="td2">{{$t('Q3')}}</td> <td class="td2">{{$t('IQR')}}</td><td class="td2">{{$t('SD')}}</td>
          <td  class="td2">{{$t('CV')}}</td> <td class="td1">{{$t('SE1')}}</td><td class="td2">{{$t('high')}}</td> <td class="td2">{{$t('low')}}</td>
          <td class="td1">{{$t('target')}}</td><td class="td2">{{$t('aucAbove')}}</td><td class="td2">{{$t('aucBelow')}}</td>
          <td class="td2">{{$t('#high')}}</td><td class="td1">{{$t('#low')}}</td><td class="td2">{{$t('high')}}%</td>
          <td class="td2">{{$t('low')}}%</td><td class="td1">{{$t('target')}}%</td>
          <td class="td2">{{$t('Avg')}}</td> <td class="td2">{{$t('SD')}}</td><td class="td2">{{$t('#hypo')}}</td><td class="td2">{{$t('bgRead')}}</td>
        </tr>
        <tr v-for="(day,j) in xDate2">
          <td class="td1">{{day}}</td>
          <td class="td2">{{glucose[j].sg_avg}}</td><td class="td2">{{glucose[j].sg_max}}</td><td class="td2">{{glucose[j].sg_min}}</td><td class="td2">{{glucose[j].sg_median}}</td>
          <td class="td2">{{glucose[j].sg_q1}}</td><td class="td2">{{glucose[j].sg_q3}}</td><td class="td2">{{glucose[j].sg_iqr}}</td><td class="td2">{{glucose[j].sg_sd}}</td>
          <td class="td2">{{glucose[j].sg_cv}}</td><td class="td1">{{glucose[j].sg_se}}</td>
          <td class="td2">{{glucose[j].sg_up}}</td>  <td class="td2">{{glucose[j].sg_lp}}</td><td class="td1">{{glucose[j].sg_tp}}</td>
          <td class="td2">{{glucose[j].sg_aucu}}</td><td class="td2">{{glucose[j].sg_aucl}}</td><td class="td2">{{glucose[j].sg_nu}}</td><td class="td1">{{glucose[j].sg_nl}}</td>
          <td class="td2">{{glucose[j].bg_up}}</td><td class="td2">{{glucose[j].bg_lp}}</td><td class="td1">{{glucose[j].bg_tp}}</td>
          <td class="td2">{{glucose[j].bg_avg}}</td><td class="td2">{{glucose[j].bg_sd}}</td><td class="td2">{{glucose[j].bg_hypo_num}}</td><td class="td2">{{glucose[j].bg_num}}</td>
        </tr>
        <tr>
          <td class="td3">{{$t('Avg/Total')}}</td>
          <td>{{glucose[dayNum].sg_avg}}</td><td>{{glucose[dayNum].sg_max}}</td><td>{{glucose[dayNum].sg_min}}</td><td>{{glucose[dayNum].sg_median}}</td>
          <td>{{glucose[dayNum].sg_q1}}</td><td>{{glucose[dayNum].sg_q3}}</td><td>{{glucose[dayNum].sg_iqr}}</td><td>{{glucose[dayNum].sg_sd}}</td>
          <td>{{glucose[dayNum].sg_cv}}</td><td class="td3">{{glucose[dayNum].sg_se}}</td>
          <td>{{glucose[dayNum].sg_up}}</td><td>{{glucose[dayNum].sg_lp}}</td><td class="td3">{{glucose[dayNum].sg_tp}}</td>
          <td>{{glucose[dayNum].sg_aucu}}</td><td>{{glucose[dayNum].sg_aucl}}</td><td>{{glucose[dayNum].sg_nu}}</td><td class="td3">{{glucose[dayNum].sg_nl}}</td>
          <td>{{glucose[dayNum].bg_up}}</td><td>{{glucose[dayNum].bg_lp}}</td><td class="td3">{{glucose[dayNum].bg_tp}}</td>
          <td>{{glucose[dayNum].bg_avg}}</td><td>{{glucose[dayNum].bg_sd}}</td><td>{{glucose[dayNum].bg_hypo_num}}</td><td>{{glucose[dayNum].bg_num}}</td>
        </tr>
      </table>
    </div>
    <div class="page-seperator"></div>
    <div class="page-starter"><!--<br/><br/><br/><br/><br/><br/><br/><br/><br/>--></div>
    <el-row>
      <el-col :span="24">
        <img id="img4_2" class="graph">
      </el-col>
    </el-row>
    <div class="statics spe-statics">
      <p>{{$t('static')}}</p>
      <table class="statics-table" :class="{'de2':isDe}">
        <tr>
          <td rowspan="2" width="11%" class="td1">{{$t('static')}}</td>
          <td colspan="5"  class="td1">{{$t('insulin2')}}</td>
          <td colspan="2"  class="td1">{{$t('carbs')}}</td>
          <td colspan="2" class="td2">{{$t('exercise')}}</td>
        </tr>
        <tr>
          <td class="td1">{{$t('total')}} {{$t('ins_unit')}}</td> <td class="td1">{{$t('avg_daily_basal')}}</td> <td class="td1">{{$t('avg_daily_bolus')}}</td> <td class="td1">{{$t('ofBolus')}}</td> <td class="td1">{{$t('avgBolus')}}</td>
          <td class="td1">{{$t('carbs')}} (g)</td> <td class="td1">{{$t('ofMeal')}}</td><td class="td1">{{$t('Dura1')}}</td><td  class="td2">{{$t('ofExer')}}</td>
        </tr>
        <tr v-for="(day,i) in xDate2">
          <td class="td1">{{day}}</td>
          <td class="td1">{{event[i].ins_total}}</td>
          <td class="td1">
            <span class="value_percent_cell left_value">{{event[i].ins_basal}}</span>
            <span class="value_percent_cell right_percent">{{event[i].ins_basal_p}}</span>
          </td>
          <td class="td1">
            <span class="value_percent_cell left_value">{{event[i].ins_bolus}}</span>
            <span class="value_percent_cell right_percent">{{event[i].ins_bolus_p}}</span>
          </td>
          <td class="td1">{{event[i].ins_bolus_n}}</td>
          <td class="td1">{{event[i].ins_bolus_avg}}</td><td class="td1">{{event[i].carb_gram}}</td><td class="td1">{{event[i].carb_num}}</td>
          <td class="td1">{{event[i].exer_time}}</td><td class="td2">{{event[i].exer_num}}</td>
        </tr>
        <tr>
          <td class="td3">{{$t('Avg/Total')}}</td>
          <td class="td3">{{event[dayNum].ins_total}}</td>
          <td class="td3">
            <span class="value_percent_cell left_value">{{event[dayNum].ins_basal}}</span>
            <span class="value_percent_cell right_percent">{{event[dayNum].ins_basal_p}}</span>
          </td>
          <td class="td3">
            <span class="value_percent_cell left_value">{{event[dayNum].ins_bolus}}</span>
            <span class="value_percent_cell right_percent">{{event[dayNum].ins_bolus_p}}</span>
          </td>
          <td class="td3">{{event[dayNum].ins_bolus_n}}</td><td class="td3">{{event[dayNum].ins_bolus_avg}}</td><td class="td3">{{event[dayNum].carb_gram}}</td>
          <td class="td3">{{event[dayNum].carb_num}}</td><td class="td3">{{event[dayNum].exer_time}}</td><td>{{event[dayNum].exer_num}}</td>
        </tr>
      </table>
    </div>
    <div class="page-end"></div>
  </div>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  import auth from '../../auth/auth'
  import B64 from '../../auth/base64'
  import dataTool from '../../auth/dataTool'
  export default{
    data() {
      return {
        xDate2:[], timeRange:'', weekmode:'yyyyyyy', uid:0,st:0,et:0,isEn:false,isMg:'',ts:[],
        statics:{},devices:['--','--','--'],hb1c:['--'],dayNum:0,interval:'',isDe:false,isIt:false,
        styleText:'<style type="text/css" media="print">@page{size:landscape;margin:0;}</style>',
        glucose: [
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
          {
            "bg_avg": '--',
            "bg_hypo_num": '--',    // 严重低个数
            "bg_lp":'--',       // 偏低百分比
            "bg_tp":'--',       // 正常百分比
            "bg_up":'--',       // 偏高百分比
            "bg_low_num": '--',
            "bg_num": '--',
            "bg_sd": '--',
            "sg_aucl": "--",
            "sg_aucu": "--",
            "sg_avg": "--",
            "sg_cv": "--",
            "sg_iqr": "--",
            "sg_lp": "--",
            "sg_lpr": "--",
            "sg_max": "--",
            "sg_median": "--",
            "sg_min": "--",
            "sg_mpr": "--",
            "sg_nl": "--",
            "sg_nu": "--",
            "sg_q1": "--",
            "sg_q3": "--",
            "sg_sd": "--",
            "sg_sdr": "--",
            "sg_se": "--",
            "sg_spr": "--",
            "sg_tp": "--",
            "sg_up": "--",
          },
        ],
        event:[
          {
          "carb_gram": '--',
          "carb_num": '--',
          "exer_num": '--',
          "exer_time": '--',
          "ins_basal": '--',
          "ins_bolus": '--',
          "ins_bolus_avg": "--",
          "ins_bolus_n": '--',
          "ins_bolus_p": "--",
          "ins_total": '--',
          "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
          {
            "carb_gram": '--',
            "carb_num": '--',
            "exer_num": '--',
            "exer_time": '--',
            "ins_basal": '--',
            "ins_bolus": '--',
            "ins_bolus_avg": "--",
            "ins_bolus_n": '--',
            "ins_bolus_p": "--",
            "ins_total": '--',
            "other": "--",
          },
      ],
      }
    },
    methods: {
      getTaReportInfo(report_data) {
        let data =  report_data;
        //console.log('ta.data:'+JSON.stringify(data));
        data.medical_history = (data.medical_history )?this.$t(data.medical_history):"--";
        this.statics = data;
        this.devices = (data.devices)?data.devices:this.devices;
        if ('EasyPatch'==this.devices[0]) {
          document.getElementById('reportPdmTitle').innerHTML='APP';
        }
        this.hb1c = (data.hba1c)?data.hba1c:this.hb1c;
        this.glucose = (data.glucose_stat)?data.glucose_stat:this.glucose;
        this.glucose.map(function (e,i) {
          if(e.bg_up!=='--'){
            e.bg_up = e.bg_up.toFixed(1);
          }
          if(e.bg_tp!=='--'){
            e.bg_tp = e.bg_tp.toFixed(1);
          }
          if(e.bg_lp!=='--'){
            e.bg_lp = e.bg_lp.toFixed(1);
          }
        });
        this.dayNum = this.glucose.length-1;
        this.event = (data.insulin_and_event_stat)?data.insulin_and_event_stat:this.event;
        let t = (this.interval!=='d')?3000:2000;
        setTimeout(auth._printPdf(),t);
      },
      /*getStatics(param){
        this.$http.get('api/v2.1/report/'+this.uid+'/data/ta',{params:{param}}).then(function (res) {
          let err =res.body.error;
        //  console.log(res);
          if(err === 0){
            let data =  res.data.data;
            //console.log('ta.data:'+JSON.stringify(data));
            data.medical_history = (data.medical_history )?this.$t(data.medical_history):"--";
            this.statics = data;
            this.devices = (data.devices)?data.devices:this.devices;
            this.hb1c = (data.hba1c)?data.hba1c:this.hb1c;
            this.glucose = (data.glucose_stat)?data.glucose_stat:this.glucose;
            this.glucose.map(function (e,i) {
              if(e.bg_up!=='--'){
                e.bg_up = e.bg_up.toFixed(1);
              }
              if(e.bg_tp!=='--'){
                e.bg_tp = e.bg_tp.toFixed(1);
              }
              if(e.bg_lp!=='--'){
                e.bg_lp = e.bg_lp.toFixed(1);
              }
            });
            this.dayNum = this.glucose.length-1;
            this.event = (data.insulin_and_event_stat)?data.insulin_and_event_stat:this.event;
            let t = (this.interval!=='d')?3000:2000;
            setTimeout(auth._printPdf(),t);
          }
        },function(err){
          this.$message.error('Try again!');
        })
      },*/
      printPdf(){
        auth.print_page();
      },
    },
    mounted: function () {
      self.document.title =this.$t('TrendRe');
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isDe = (lang==='de')?true:false;
      this.isIt = (lang==='it')?true:false;
      this.isMg = (localStorage.getItem('unit')==='mg')?true:false;
      if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      this.et= parseInt(sessionStorage.getItem('et4'));
      this.st= parseInt(sessionStorage.getItem('st4'));
      let days =parseInt((this.et-this.st)/86400)+1;
      if(days<=7){ this.interval='d';}
      else if(days<=56){ this.interval='w';}
      else{ this.interval='m';}
      //
      let timeIntervalSelect=sessionStorage.getItem('timeIntervalSelect4');
      timeIntervalSelect=parseInt(timeIntervalSelect);
      console.log("timeIntervalSelect:", timeIntervalSelect);
      if (NaN==timeIntervalSelect || !(timeIntervalSelect>=1&&timeIntervalSelect<=3)) {
        return;
      }

      if (1==timeIntervalSelect){
        this.interval='d';
      } else if (2==timeIntervalSelect) {
        this.interval='w';
      } else if (3==timeIntervalSelect) {
        this.interval='m';
      }
      //
      this.weekmode = sessionStorage.getItem('week4');
      this.timeRange = sessionStorage.getItem('timeRange4');
      this.xDate2 = JSON.parse(sessionStorage.getItem('xDate4'));
      this.ts = JSON.parse(sessionStorage.getItem('xTs4'));
     // console.log(this.ts,this.interval);
      let param = {
        ts:this.ts,
        interval:this.interval,
        tz:parseInt(sessionStorage.getItem('tz')),
        weekmode:this.weekmode,
        gu:(this.isMg)?'mg/dL':'mmol/L',
      };
      param = B64.base64encode(JSON.stringify(param));
      //this.getStatics(param);
      let report_data = JSON.parse(sessionStorage.getItem('ta_report_data'))
      this.getTaReportInfo(report_data);
      let img1 = document.getElementById('img4_1');
      img1.src = sessionStorage.getItem('src4_1');
      let img2 = document.getElementById('img4_2');
      img2.src = sessionStorage.getItem('src4_2');
    },
  }
</script>

<style scoped meadia="print">
  /*@page{
    *size:auto;
    size:landscape;
    margin: 0;
  }*/
  .background{
    padding-top: 5mm;
    width: 100%;
    *min-height: 317mm;
    background: #ccc;
  }
  .background .noPrint{
    float: left;
    border-radius:100px;
    background: #fff;
    border: 1px solid #a3a3a3;
    outline: none;
    margin-top:4px;
    width:90px;
    height:26px;
    line-height: 28px;
    cursor: pointer;
    margin-left:-140px;
    font-size: 13px;
    text-align: center;
  }
  @media print {
    .background .noPrint{
      display: none;
    }
  }
  .chart-container {
    width:297mm;
    *min-height:317mm;
    font-family:SFUIText-Regular;
    font-size:13px;
    color:#282828;
    letter-spacing:-0.34px;
    background: #fff;
    margin:0 auto;
    padding-left: 20px;
    padding-right: 20px;
  }
  @media screen and (max-width: 1450px){
    .background .noPrint{
      position: absolute;
      left: 20%;
      top: -1px;
    }
    .chart-container{
      margin-top: 20px;
    }
  }
  .Hcp-main-header{
    width:97%;
    height:40px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:13px;
    color:#282828;
    padding-top: 10px;
  }
  .main-header-left{
    float: left;
  }
  .main-header-left img{
    height:45px;
    width: 100px;
  }
  .main-header-right{
    float: right;
    text-align: right;
    padding-top: 10px;
    margin-right: 15px;
  }
  .main-header-right p{
    font-size:12px;
    margin-bottom: 5px;
    letter-spacing:-0.29px;
    font-family:SFUIText-Regular;
    color:#282828;
  }

  .status-table1{
    width: 94%;
    margin:20px auto 16px;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:left;
    table-layout: fixed;
    font-size:12px;
  }
  .status-table1 td{
    padding-left: 8px;
    height:15px;
  }
  .status-table1 .td1{
    width: 14%;
  }
  .zh1 .td1{
    width: 12%;
  }
  .de1 .td1{
    width: 11%;
  }
  .de1 td{
    padding-left: 3px;
  }
  .status-table1 .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .status-table1 .td3{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .status-table1 .td4{
    border-right:1px solid rgba(116,116,116,0.34);
  }

  .small-hr{
    width:94%;
    margin:10px auto 16px;
    border-top:1px solid #3b3b3b;
  }
  .chart-container .graph{
    width:97%;
    height:150px;
    margin-left: 2%;
    margin-bottom: 5px;
  }

  .statics{
    clear: both;
    margin-top: 10px;
    margin-bottom: 55px;
  }
  .statics p{
    font-family:SFUIText-Regular;
    font-size:14px;
    color:#282828;
    letter-spacing:-0.27px;
    margin-left: 4%;
  }
  .statics-table{
    width: 94%;
    margin:10px auto 0;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:center;
  }
  .de2{
    word-wrap: break-word;
    word-break: break-all;
  }
  .statics-table td{
    font-size:13px;
    height:15px;
  }
  .statics-table .td1{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td3{
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .spe-statics{
    margin-bottom: 10px;
  }
  .spe-statics table{
    table-layout: fixed;
  }
  .value_percent_cell {
    display: block;
    float: left;
    width:50%;
  }

  .page-seperator {
    *margin-top:4cm;
    page-break-before: always;
  }

  .page-starter {
    height:10mm;
  }

  .page-end {
    clear: both;
    height:10mm;
  }
</style>





// WEBPACK FOOTER //
// chart4_print.vue?5cb7c8e1